module.exports = __webpack_public_path__ + "static/fe-2020-d6dbb566aab4a75fdd5d7f0e146105f8.png";